// extracted by mini-css-extract-plugin
export default {"payroll-sum-emp-header":"PayrollSummEmpReport_payroll-sum-emp-header__WkP-z","divider":"PayrollSummEmpReport_divider__cOTWe"};